module.exports = __webpack_public_path__ + "static/media/replace-image-tool-white.ebed6339.svg";